import * as DOMPurify from 'dompurify';
import simplifiedQuestionIdsMap from "./simplifiedQuestionIdsMap.json"

export function sanitizeHtml(htmlStr: string) {
    return DOMPurify.sanitize(htmlStr, { ALLOWED_TAGS: ['span', 'b', 'em'], ALLOWED_ATTR: ['class'] });
}

export interface ISimplifiedQuestion {
    questionId: string
    questionNumber: number
    lessonId: string
}

export interface ISimplifiedQuestionsMap {
    [questionId: string]: Partial<ISimplifiedQuestion>
}

/**
 * Returns the simplified question based on the questionId by checking the map
 * @param simplifiedQuestionsMap 
 * @param questionId 
 * @returns simplified question or null if not found
 */
export function getSimplifiedQuestionByQuestionId(simplifiedQuestionsMap: ISimplifiedQuestionsMap, questionId: string): ISimplifiedQuestion|null {
    let question = simplifiedQuestionsMap[questionId]

    if (question) {
        return {questionId, ...question} as ISimplifiedQuestion
    } else {
        return null
    }
}

/**
 * Given the questionId it returns the question number 
 * @param questionId 
 * @returns questionNumber or -1 if not found
 */
export function getQuestionNumberByQuestionId(questionId: string): number {
    let simplifiedQuestion = getSimplifiedQuestionByQuestionId(simplifiedQuestionIdsMap, questionId)
    return simplifiedQuestion?.questionNumber ?? -1
}
